module.exports = __webpack_public_path__ + "static/media/colheitadeira2.c37ee56b.svg";